import api from "@/lib/api";

// File d'attente des sauvegardes hors-ligne (localStorage) + cache local des constats.
// Sécurité : aucun secret ici (l'authentification est en cookie httpOnly) ; seules des données métier
// de constats sont stockées, indispensables au mode hors-ligne sur tablette.
const QUEUE_KEY = "madlo.queue";
const ETAT_KEY = (id) => `madlo.etat.${id}`;
const listeners = new Set();
let flushing = false;

export const isNetworkError = (err) => !err?.response || err.response.status === 503 || err.code === "ERR_NETWORK";

export function cacheEtat(etat) {
  try { localStorage.setItem(ETAT_KEY(etat.id), JSON.stringify({ etat, at: Date.now() })); } catch (e) { console.warn("Cache local du constat impossible (quota)", e?.message); }
}
export function readCachedEtat(id) {
  try { const raw = localStorage.getItem(ETAT_KEY(id)); return raw ? JSON.parse(raw) : null; } catch { return null; }
}

function readQueue() { try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || "{}"); } catch { return {}; } }
function writeQueue(q) { localStorage.setItem(QUEUE_KEY, JSON.stringify(q)); listeners.forEach((fn) => fn(pendingCount())); }

export function enqueueSave(id, data) {
  const q = readQueue();
  q[id] = { data, at: Date.now() };
  writeQueue(q);
}
export function pendingCount() { return Object.keys(readQueue()).length; }
export function hasPending(id) { return !!readQueue()[id]; }
export function onQueueChange(fn) { listeners.add(fn); return () => listeners.delete(fn); }

export async function flushQueue() {
  if (flushing || !navigator.onLine) return { sent: 0, failed: 0 };
  flushing = true;
  let sent = 0, failed = 0;
  try {
    const q = readQueue();
    for (const [id, item] of Object.entries(q)) {
      try {
        const { data } = await api.put(`/etats/${id}`, item.data);
        cacheEtat(data);
        delete q[id]; writeQueue(q); sent++;
      } catch (err) {
        if (isNetworkError(err) || err?.response?.status === 401) { failed++; break; }
        delete q[id]; writeQueue(q); failed++;
      }
    }
  } finally { flushing = false; }
  return { sent, failed };
}

export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}
